import { createContext } from 'react';

export type ViewMode = 'live' | 'stress-test';

export interface ViewModeContextValue {
  mode: ViewMode;
}

export const ViewModeContext = createContext<ViewModeContextValue>({ mode: 'live' });
